module.exports = __webpack_public_path__ + "img/badge-exercises.cfd5cc7f.svg";